module.exports = __webpack_public_path__ + "img/banner-ksg@1x.e8cb244d.jpg";